<template>
  <span :class="containerClassName">
    {{ groupCount }}
  </span>
</template>
<script>
import { DirectoryGroupingConsts } from 'client/util/Constants';
import { mapGetters } from 'vuex';

export default {
  name: 'SystemUserGroupCount',

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  computed: {
    ...mapGetters('SystemCollection', {
      getGroupMembership: 'getGroupMembership',
      selectedItems: 'getSelectedItems',
    }),

    containerClassName() {
      const classNames = [this.$style.container];

      if (this.isSelected) {
        classNames.push(this.$style.visible);
      }

      return classNames.join(' ');
    },

    groupCount() {
      const { groupTypes } = DirectoryGroupingConsts;
      const userGroups = this.getGroupMembership(this.item.id, groupTypes.userGroup);
      return (userGroups && userGroups.length) || '';
    },

    isSelected() {
      return this.selectedItems.indexOf(this.item.id) !== -1;
    },
  },
};
</script>
<style module scoped>
@value (panelSpeed, panelTimingFunction) from '~css/transitions.css';

.container {
  opacity: 0;
  transition: opacity panelSpeed panelTimingFunction;
}

.visible {
  opacity: 1;
}
</style>
